import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaMapMarkerAlt, FaPhoneAlt, FaWhatsapp, FaEnvelope } from 'react-icons/fa';
import './contact.css';

const ContactCard = ({ icon, title, children }) => {
  return (
    <Card className="contact-box">
      <div className="contact-icon">{icon}</div>
      <Card.Title className="contact-title">{title}</Card.Title>
      <Card.Text className="contact-text">{children}</Card.Text>
    </Card>
  );
};

const Contact = () => {
  return (
    <div className="contact-section">
      <Container>
        <h2 className="contact-heading">Contact Us</h2>
        <Row className="justify-content-center g-3">
          <Col xs={12} sm={6} lg={3}>
            <ContactCard icon={<FaMapMarkerAlt />} title="Address">
              VO-656 AT WE WORK BERGER ONE, SECTOR16B, C-001/A2, Gautam Buddha Nagar, Noida, Uttar Pradesh, 201301.
            </ContactCard>
          </Col>
          <Col xs={12} sm={6} lg={3}>
            <ContactCard icon={<FaPhoneAlt />} title="Connect US">
              (+91) 9211460800 <br />
              Office hours: 10:00AM - 7:00PM
            </ContactCard>
          </Col>
          <Col xs={12} sm={6} lg={3}>
            <ContactCard icon={<FaWhatsapp />} title="Whatsapp">
              (+91) 9211460800 <br />
              Office hours: 10:00AM - 7:00PM
            </ContactCard>
          </Col>
          <Col xs={12} sm={6} lg={3}>
            <ContactCard icon={<FaEnvelope />} title="Mail US">
              info@dhanwalle.com <br />
              Office hours: 10:00AM - 7:00PM
            </ContactCard>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Contact;
